<bari-modal [closeicon]="true" [busy]="busy">
  <div modal-header>
    <span>Aviso de viagem</span>
  </div>
  <div modal-body>
    <p>Para configurar seu aviso de viagem, precisamos saber qual será seu destino:</p>

    <div class="locations">
      <label for="item-{{country.name}}" class="locations-item" *ngFor="let country of countries">
        <input type="checkbox" id="item-{{country.name}}" name="item-{{country.name}}"> {{country.name}}
      </label>
    </div>

    <div class="error" *ngIf="error.hasError">
      {{error.message}}
    </div>
  </div>
  <footer>
    <bari-button
      size="big"
      color="dark"
      text="between"
      icon="arrow-right"
      iconColor="#fff"
      (click)="successModal()"
    >
      Ativar aviso
    </bari-button>
  </footer>
</bari-modal>
